import { QueryClient } from '@tanstack/react-query';

import { ApiError } from '@/integrations/api';

export const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        // Responses are never cached by the server; always treat data as stale.
        staleTime: 0,
        keepPreviousData: true,
        refetchOnWindowFocus: true,
        // A 404 will not fix itself; everything else gets one more try.
        retry: (failureCount, error) =>
          !(error instanceof ApiError && error.kind === 'notFound') && failureCount < 1,
      },
    },
  });

export const queryClient = createQueryClient();
